import React from "react";
import { useQuickSightSagemaker } from "@/hooks/useSagemakerReports";

const QuickSightAwsSagemakerDashboard = () => {
  const { embedUrl } = useQuickSightSagemaker();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsSagemakerDashboard;
